import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { SiteProvider } from "@/context/SiteContext";
import { initLenis } from "@/lib/smooth";
import ErrorBoundary from "@/components/ErrorBoundary";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Details from "@/components/Details";
import Marquee from "@/components/Marquee";
import Gallery from "@/components/Gallery";
import Tour360 from "@/components/Tour360";
import Neighbourhood from "@/components/Neighbourhood";
import ContactAgent from "@/components/ContactAgent";
import Footer from "@/components/Footer";
import PhotoFlyout from "@/components/PhotoFlyout";
import AdminPage from "@/components/AdminPage";

function Home() {
  return (
    <div className="min-h-screen bg-[#FAFAFA] font-sans text-zinc-900 antialiased dark:bg-[#0B0C0E] dark:text-zinc-100">
      <Navbar />
      <main>
        <Hero />
        <Details />
        <Marquee />
        <Gallery />
        <Tour360 />
        <Neighbourhood />
        <ContactAgent />
      </main>
      <Footer />
      <PhotoFlyout />
      <Toaster position="bottom-right" richColors />
    </div>
  );
}

export default function App() {
  useEffect(() => initLenis(), []);

  return (
    <ErrorBoundary>
      <BrowserRouter>
        <SiteProvider>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </SiteProvider>
      </BrowserRouter>
    </ErrorBoundary>
  );
}
